import { render } from "./MessageDialog.vue?vue&type=template&id=24492dd6&scoped=true"
import script from "./MessageDialog.vue?vue&type=script&lang=js"
export * from "./MessageDialog.vue?vue&type=script&lang=js"

import "./MessageDialog.vue?vue&type=style&index=0&id=24492dd6&scoped=true&lang=css"

import exportComponent from "/home/xs551928/niidaphoto.com/oyadori/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24492dd6"]])

export default __exports__